import { useMemo } from 'react';

import { IStateAwareArea } from 'types/map';

export function useCursor(area: IStateAwareArea, zoomLevel: number) {
  return useMemo(() => {
    if (area.isDistrict) {
      return 'pointer';
    }
    if (area.isLandmark) {
      return 'grab';
    }
    if (!area.isLandmark && area.shouldBeInteractiveAtZoomLevel(zoomLevel) ? 'pointer' : 'grab') {
      return 'pointer';
    }
    return 'grab';
  }, [area, zoomLevel]);
}
